import React from "react";
import { PConfirmDialogStyle as S } from "./PConfirmDialog.style";
import { ConfirmDialog, ConfirmDialogProps } from "primereact/confirmdialog";

export const PConfirmDialog = React.forwardRef<ConfirmDialog, ConfirmDialogProps>((props, ref) => (
  <>
    <S.PConfirmDialog pt={{ root: { "data-testid": "delete-confirmation-modal" } }} {...props} ref={ref} />
  </>
));
